var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "search_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#search_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M33 34.972 22.195 24.167a9.41 9.41 0 0 1-2.902 1.652 10.256 10.256 0 0 1-3.515.598c-3.013 0-5.562-1.044-7.648-3.132C6.043 21.197 5 18.667 5 15.695c0-2.973 1.044-5.503 3.132-7.59 2.088-2.089 4.623-3.133 7.604-3.133 2.982 0 5.512 1.044 7.59 3.132 2.08 2.088 3.119 4.62 3.119 7.595a10.302 10.302 0 0 1-2.278 6.495L35 32.972l-2 2ZM15.75 23.64c2.2 0 4.068-.776 5.608-2.326 1.539-1.551 2.309-3.424 2.309-5.619 0-2.194-.77-4.067-2.31-5.618-1.539-1.55-3.408-2.326-5.607-2.326-2.214 0-4.097.775-5.647 2.326-1.55 1.551-2.325 3.424-2.325 5.618 0 2.195.775 4.068 2.325 5.618 1.55 1.551 3.433 2.327 5.647 2.327Z"
}))));
export default SvgSearch;